import { render } from "./OfferTokenStatusChip.vue?vue&type=template&id=c952ddca&scoped=true"
import script from "./OfferTokenStatusChip.vue?vue&type=script&lang=js"
export * from "./OfferTokenStatusChip.vue?vue&type=script&lang=js"

import "./OfferTokenStatusChip.vue?vue&type=style&index=0&id=c952ddca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c952ddca"]])

export default __exports__